import { Route, useLocation, Routes, Navigate } from 'react-router-dom';
import { Suspense, useEffect } from 'react';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';
import LoadingPage from './components/global/LoadingPage';
import Login from './pages/auth/Login';
import ProtectedRoute from './components/global/ProtectedRoute';
import Home from './pages/Home';
import Layout from './layout/Layout';
import Register from './pages/auth/Register';
import Profile from './pages/profile/Profile';

// Import modular routes
import rolesRoutes from './routes/rolesRoutes';
import settingsRoutes from './routes/settingsRoutes';
import comingSoonRoutes from './routes/comingSoonRoutes';
import usersRoutes from './routes/usersRoutes';
import clientsRoutes from './routes/clientsRoutes';
import servicesRoutes from './routes/servicesRoutes';
import projectsRoutes from './routes/projectsRoutes';
import contactsRoutes from './routes/contactsRoutes';
import aboutRoutes from './routes/aboutRoutes.jsx';
import testimonialsRoutes from './routes/testimonialsRoutes';
import whyChooseUsRoutes from './routes/whyChooseUsRoutes';
import aboutHeaderRoutes from './routes/aboutHeaderRoutes';
import homeHeaderRoutes from './routes/homeHeaderRoutes';
import ugcRoutes from './routes/ugcRoutes';
import blogSectionRoutes from './routes/blogSectionRoutes';
import blogCategoriesRoutes from './routes/blogCategoriesRoutes';
import blogTagsRoutes from './routes/blogTagsRoutes';
import blogPostsRoutes from './routes/blogPostsRoutes';
import serviceSettingsRoutes from './routes/serviceSettingsRoutes';
import projectSettingsRoutes from './routes/projectSettingsRoutes';

// Pages
const RoutesPath = () => {
    const ScrollToTop = () => {
        const { pathname } = useLocation();
        useEffect(() => {
            window.scrollTo(0, 0);
        }, [pathname]);
        return null;
    };

    return (
        <>
            <ScrollToTop />
            <Suspense fallback={<LoadingPage />}>
                <Routes>
                    {/* Auth Routes */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />

                    {/* 403 Forbidden Page */}
                    <Route path="/forbidden" element={<Forbidden />} />

                    {/* Protected Routes */}
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <Layout />
                            </ProtectedRoute>
                        }>

                        {/* Home - Redirect to dashboard */}
                        <Route index element={<Navigate replace to="dashboard" />} />

                        {/* Dashboard - Available for all authenticated users */}
                        <Route path="dashboard" element={<Home />} />

                        {/* Profile - Available for all authenticated users */}
                        <Route path="profile" element={<Profile />} />

                        {/* Settings - Requires permission */}
                        {/* <Route
                            path="setting"
                            element={
                                <ProtectedRoute requiredPermission="settings_companies">
                                    <Settings />
                                </ProtectedRoute>
                            }
                        /> */}

                        {/* ============================================ */}
                        {/* Modular Routes - Each module in its own file */}
                        {/* ============================================ */}

                        {/* Users Module */}
                        {usersRoutes}

                        {/* Clients Module */}
                        {clientsRoutes}

                        {/* Services Module */}
                        {servicesRoutes}

                        {/* Projects Module */}
                        {projectsRoutes}

                        {/* Contacts Module */}
                        {contactsRoutes}

                        {/* About Module */}
                        {aboutRoutes}

                        {/* Roles & Permissions */}
                        {rolesRoutes}

                        {/* Settings */}
                        {settingsRoutes}

                        {/* Testimonials Module */}
                        {testimonialsRoutes}

                        {/* UGC Module */}
                        {ugcRoutes}

                        {/* About Header Module */}
                        {aboutHeaderRoutes}

                        {/* Home Header Module */}
                        {homeHeaderRoutes}

                        {/* Why Choose Us Module */}
                        {whyChooseUsRoutes}

                        {/* Service Settings */}
                        {serviceSettingsRoutes}

                        {/* Project Settings */}
                        {projectSettingsRoutes}

                        {/* Blog Module */}
                        {blogSectionRoutes}
                        {blogCategoriesRoutes}
                        {blogTagsRoutes}
                        {blogPostsRoutes}

                        {/* Placeholder routes for upcoming modules. */}
                        {comingSoonRoutes}

                        {/* ============================================ */}
                        {/* Add more modular routes here */}
                        {/* ============================================ */}

                    </Route>
                    {/* End Protected Routes */}

                    {/* 404 Not Found */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
        </>
    );
};

export default RoutesPath;